import { render, staticRenderFns } from "./PaypalAccount.vue?vue&type=template&id=78cbbf7b&scoped=true"
import script from "./PaypalAccount.vue?vue&type=script&lang=js"
export * from "./PaypalAccount.vue?vue&type=script&lang=js"
import style0 from "./PaypalAccount.vue?vue&type=style&index=0&id=78cbbf7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cbbf7b",
  null
  
)

export default component.exports